import React, {useEffect, useState} from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle.js";

import LoginPage from "../views/Pages/LoginPage";
import {useSelector} from "react-redux";
import {APP_LOGO, APP_NAME, AUTH_BG} from "../config";
import LockScreenPage from "../views/Pages/LockScreenPage";
import {setIsSessionTimeout} from "../store/app/actions";

const useStyles = makeStyles(styles);

export default function Pages(props) {
  const { ...rest } = props;
  // ref for the wrapper div
  const wrapper = React.createRef();
  // styles
  const classes = useStyles();
  React.useEffect(() => {
    document.body.style.overflow = "unset";
    // Specify how to clean up after this effect:
    return function cleanup() {};
  });
  const isAuthenticated = useSelector(state => state.app.isAuthenticated);
  const isSessionTimeout = useSelector(state => state.app.isSessionTimeout);

  return (
    <div>
      {/*<AuthNavbar brandLogo={APP_LOGO} brandText={APP_NAME} {...rest} />*/}
      <div className={classes.wrapper} ref={wrapper}>
          {!isAuthenticated && <LoginPage />}
          {isAuthenticated && isSessionTimeout && <LockScreenPage />}
      </div>
    </div>
  );
}
